import React from 'react';

import { Flex } from '../../../GlobalComponents/Flex';
import { RootStates } from '../../../reduxstore';
import { useAppSelector } from '../../../reduxstore/hooks';
import FavoriteProducts from './containers/FavoriteProducts';
import FavoriteStore from './containers/FavoriteStore';

const FavoriteStoreIndex: React.FC = () => {
	// Continue work after re-doing Favorite Store and Favorite Product models

	const favoriteProducts = useAppSelector(
		(state: RootStates) => state.accountReducer.profile.favorite_products
	);

	const favoriteStores = useAppSelector(
		(state: RootStates) => state.accountReducer.profile.favorite_stores
	);

	return (
		<Flex $flexDirection="column" $rowGap="48px">
			<FavoriteStore stores={favoriteStores} />
			{favoriteProducts.length > 0 && (
				<FavoriteProducts products={favoriteProducts} />
			)}
		</Flex>
	);
};

export default FavoriteStoreIndex;
